module.exports = __webpack_public_path__ + "img/15600.c19a0ca4.jpg";